<template>
    <div class="modal fade share-bet-modal" id="qrPreviewModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <button type="button" class="cross_btn_top" data-bs-dismiss="modal" aria-label="Close">&#10006;</button>
                <div class="modal-body">
                    <section class="sub-header-wrapper">
                        <div class="qrPreview-image">
                            <a href="javascript:void(0)">
                                <img :src="qrCode" class="offer-img" alt="qrcodeimage" loading="lazy">
                            </a>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'qrCodeModal',
    props: ['qrCode']
}
</script>